import { render, staticRenderFns } from "./PerformancePortalView.vue?vue&type=template&id=b12c50d4&scoped=true"
import script from "./PerformancePortalView.vue?vue&type=script&lang=js"
export * from "./PerformancePortalView.vue?vue&type=script&lang=js"
import style0 from "./PerformancePortalView.vue?vue&type=style&index=0&id=b12c50d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c50d4",
  null
  
)

export default component.exports